import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import TicketsApi from '@infrastructure/tickets-api';
export const uploadExcelAsync = createAsyncThunk('tickets/uploadExcel', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.uploadExcel(request.file, request.eventId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadExcelTemplateAsync = createAsyncThunk('tickets/downloadExcelTemplate', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.downloadExcelTemplate();
        return fulfillWithValue({
            data: response.data,
            headers: response.headers
        });
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllTicketsAsync = createAsyncThunk('tickets/get-all', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.getAllTickets(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignTicketsManuallyAsync = createAsyncThunk('tickets/assign-ticket-manually', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.assignTicketManually(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignTicketFromDatabaseAsync = createAsyncThunk('tickets/assign-ticket-from-database', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.assignTicketFromDatabase(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const UnassignTicketsAsync = createAsyncThunk('tickets/Unassign-ticket', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.UnassignTicket(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRelationForTicketsAsync = createAsyncThunk('tickets/get-relation-for-ticket', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.getRelationForTicket(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendTicketEmailAsync = createAsyncThunk('tickets/send-ticket-email', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.sendTicketEmail(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendBulkTicketEmailAsync = createAsyncThunk('tickets/send-bulk-ticket-email', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.sendBulkTicketEmail(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadTicketDocumentAsync = createAsyncThunk('tickets/upload-ticket-document', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await TicketsApi.uploadTicketDocument(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
